import { AdContainerStore } from '../../../../common/js/stores/ad-container.store';
import { RootStore } from '../../../../common/js/stores/root.store';
import { sendCustomTrack } from '../../../../common/js/TrackAnalyticsHelper';
import { reaction } from '../../../../common/js/utils/preact-utils';

// TODO: Rename event names to follow a consistent pattern
export class AdContainerDebugTrackHandler {
  static MAX_EXPOSURE_TRACKS = 10;

  rootStore: RootStore;
  adContainerStore: AdContainerStore;

  exposureTrackCount = 0;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.adContainerStore = rootStore.adContainerStore;

    if (!this.isEnabled()) return;

    this.trackDebugInit();
    this.initObservers();
  }

  isEnabled(): boolean {
    return this.rootStore.adContextStore.adContext.enableMraidDebugTracks;
  }

  initObservers(): void {
    this.adContainerStore.isReady.subscribe((isReady: boolean) => {
      this.sendTrack(`format_mraid_ready_${isReady}`);
    });

    this.adContainerStore.state.subscribe((state: string) => {
      this.sendTrack(`format_mraid_state_${state}`);
    });

    this.adContainerStore.isViewable.subscribe((isViewable: boolean) => {
      this.sendTrack(`format_mraid_viewable_${isViewable}`);
    });

    const unsubscribeExposureReaction = reaction(
      () => this.adContainerStore.exposure.value,
      (exposure: { percentageInView: number }) => {
        if (
          exposure.percentageInView >= AdContainerStore.MIN_PERCENTAGE_VIEWABLE
        )
          return;
        this.exposureTrackCount += 1;
        this.sendTrack('format_mraid_exposure_below_50');

        if (
          this.exposureTrackCount >=
          AdContainerDebugTrackHandler.MAX_EXPOSURE_TRACKS
        )
          unsubscribeExposureReaction && unsubscribeExposureReaction();
      },
      true
    );
  }

  trackDebugInit(): void {
    this.sendTrack(
      `format_mraid_version_` +
        this.adContainerStore.adContainerPort.getVersion()
    );

    if (this.adContainerStore.adContainerPort.hasBeenPolyfilled()) {
      this.sendTrack('format_mraid_polyfilled');
    }
  }

  sendTrack(eventName: string): void {
    sendCustomTrack(eventName);
  }
}
